import { CTAToken, Media, TOKEN_TYPE } from "@hermes/api-model-editorial";
import { GridEdito } from "@hermes/states/grid-filters-state";

export function mapGridEditoToMedia(gridEdito: GridEdito): Media {
    const media: Media = {
        videoUrl: gridEdito.videoUrl,
        videoLoopMuteAutoplay: gridEdito.videoLoopMuteAutoplay,
        alwaysShowControls: gridEdito.alwaysShowControls,
        mobileImage: gridEdito.imageMobileUrl,
        desktopImage: gridEdito.imageDesktopUrl,
        imageAlt: gridEdito.imageDesktopAlt || gridEdito.imageMobileAlt,
        imageRetouched: gridEdito.imageRetouched,
        caption: "",
        credits: "",
    };
    return media;
}

export function computeCTAToken(edito: GridEdito): CTAToken | undefined {
    return edito?.token?.tokenType === TOKEN_TYPE.ctaMissing
        ? undefined
        : edito.token;
}
